module.exports = __webpack_public_path__ + "img/rightColumn.dc15a355.png";